import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import { Button } from "~/components/ui/button";
type SocialAuthButtonProps = {
  icon: ReactNode;
  children: string;
  disabled?: boolean;
  onClick: () => void;
};
export function SocialAuthButton(t0) {
  const $ = _c(9);
  const {
    icon,
    children,
    disabled,
    onClick
  } = t0;
  let t1;
  if ($[0] !== icon) {
    t1 = <span className="flex h-[18px] w-[18px] items-center justify-center">{icon}</span>;
    $[0] = icon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children) {
    t2 = <span>{children}</span>;
    $[2] = children;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== disabled || $[5] !== onClick || $[6] !== t1 || $[7] !== t2) {
    t3 = <Button className="w-full justify-center gap-2.5" disabled={disabled} onClick={onClick} type="button" variant="social" size="md">{t1}{t2}</Button>;
    $[4] = disabled;
    $[5] = onClick;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}